var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPkMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7651_47691",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 27
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.106201,
    width: 26,
    height: 26,
    rx: 13,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7651_47691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0489 0.106201H2.34766V26.1062H31.0489V0.106201Z",
    fill: "#2A6238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24795 0.106201H-5.05078V26.1062H6.24795V0.106201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2113 8.86475L18.4113 10.2489L20.1606 9.58532L19.1556 11.1057L20.3556 12.4899L18.5328 12.0442L17.5277 13.5646L17.4087 11.7693L15.5859 11.3261L17.3328 10.66L17.2113 8.86475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8021 18.2196C13.3438 18.2196 10.5413 15.5378 10.5413 12.2297C10.5413 8.92146 13.1287 6.46013 16.3995 6.25956C16.2299 6.24717 16.0578 6.23975 15.8856 6.23975C11.9236 6.23975 8.71094 9.3127 8.71094 13.1037C8.71094 16.8948 11.9236 19.9677 15.8856 19.9677C19.8476 19.9677 23.0603 16.8948 23.0603 13.1037C23.0603 12.9378 23.0527 12.7744 23.0401 12.6135C22.8325 15.7409 20.1211 18.2171 16.7995 18.2171L16.8021 18.2196Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPkMobile);
export default __webpack_public_path__ + "static/media/pkMobile.6bf66f99813a58932e5d3a329fbc2e88.svg";
export { ForwardRef as ReactComponent };